import { useRouter } from 'fitify-ui-onboarding/src/hooks/useRouter'
import type { ImageProps } from 'fitify-ui-onboarding/src/types/ui'
import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { PAGES_CACHE } from 'fitify-ui-onboarding/src/utils/navigation'
import Head from 'next/head'
import { useMemo } from 'react'

import { getRouteImages } from 'components/RoutePrefetch/RouteImagesPrefetch.Utils'
import { getPrefetchRoutes } from 'components/RoutePrefetch/RoutePrefetch.Utils'
import { useFunnel } from 'hooks/useFunnel'
import { useCategoryImageVariant } from 'hooks/useImageProps'
import { processImageDefinition } from 'utils/images'

export const RouteImagesPrefetch = () => {
  const funnel = useFunnel()
  const router = useRouter()
  const variant = useCategoryImageVariant(funnel)
  const growthBook = useGrowthBook()

  const images = useMemo<ImageProps[]>(() => {
    if (!funnel) {
      return []
    }

    const imagesRoutes = getPrefetchRoutes(PAGES_CACHE, router.resolvedPathname)

    return imagesRoutes.reduce<ImageProps[]>((acc, route) => {
      const imageDefinitions = getRouteImages(route, funnel, variant)
      imageDefinitions.forEach((imageDefinition) => {
        const { prefetchCondition } = imageDefinition
        if (!prefetchCondition || prefetchCondition(growthBook)) {
          acc.push(processImageDefinition(imageDefinition))
        }
      })
      return acc
    }, [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [funnel, growthBook, router.isReady, router.resolvedPathname, variant])

  return (
    <Head>
      {images.map((image) => (
        <link
          key={image.src}
          rel="preload"
          as="image"
          href={image.src}
          imageSrcSet={image.srcSet}
        />
      ))}
    </Head>
  )
}
